import { createContext } from "react";
import type { ThemeTemplateKey } from "../../styles";

interface ThemeContextType {
  currentTheme: ThemeTemplateKey;
  setTheme: (theme: ThemeTemplateKey) => void;
  setTemporaryTheme: (theme: ThemeTemplateKey) => void;
}

// Exportamos solo el objeto del contexto.
// Esto es seguro para Fast Refresh.
export const ThemeContext = createContext<ThemeContextType>({
  currentTheme: "dark_yellow",
  setTheme: () => {},
  setTemporaryTheme: () => {},
});
